export default __webpack_public_path__ + "static/ot_card_1-464a0f59bc59064325a56a1ac25f41f1.jpg";